"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyCommand = exports.SetElementPropertyCommand = void 0;
const zod_1 = require("zod");
const common_1 = require("./common");
/**
 * Set a property on an element.  This cannot target document, route, or net properties.  The value passed in here
 * should be a valid, unparsed value for the property.  If the property doesn't exist, it will be created.
 */
exports.SetElementPropertyCommand = zod_1.z.object({
    type: zod_1.z.literal(common_1.CommandType.setElementPropertyCommand),
    propertyUid: zod_1.z.string(),
    /**
     * The element that we are setting the property on.
     */
    elementUid: zod_1.z.string(),
    /**
     * Name of the property that we're setting on the element.
     */
    propertyName: zod_1.z.string(),
    /**
     * The value that we're setting the property to.
     */
    rawPropertyValue: zod_1.z.string(),
});
exports.PropertyCommand = zod_1.z.discriminatedUnion("type", [exports.SetElementPropertyCommand]);
//# sourceMappingURL=properties.js.map